//import { flare } from "@flareapp/flare-client";
//import { flareVue } from "@flareapp/flare-vue";
import Vue from 'vue';
import Rellax from 'rellax';
import 'livewire-vue';
import scrollController from "./scrollmanager";

// if (process.env.NODE_ENV !== "local") {
//     flare.light("nlstkqbZqJo2n6oa5rfa8DPU01msywk0");
// }

require("./bootstrap");

const currency = require('currency.js');
const global = require('./app/global.js');
window.Cookies = require('js-cookie');
// require('./app/cookie-consent');

window.Vue = Vue;
window.VCalendar = require("v-calendar");
export const EventBus = new Vue();
Vue.component("pagination", require("laravel-vue-pagination"));

if (document.getElementById("vue")) {
//    Vue.use(flareVue);
    Vue.use(VCalendar);

    Vue.filter("longDate", function(value) {
        if (value) {
            return Intl.DateTimeFormat("en-GB", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            }).format(new Date(value));
        }
    });

    /**
     * The following block of code may be used to automatically register your
     * Vue components. It will recursively scan this directory for the Vue
     * components and automatically register them with their "basename".
     *
     * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
     */
    const files = require.context("./app/components", true, /\.vue$/i);
    files.keys().map(key =>
        Vue.component(
            key
                .split("/")
                .pop()
                .split(".")[0],
            files(key).default
        )
    );

    Vue.directive("click-outside", {
        bind(el, binding, vnode) {
            var vm = vnode.context;
            var callback = binding.value;

            el.clickOutsideEvent = function(event) {
                if (!(el == event.target || el.contains(event.target))) {
                    return callback.call(vm, event);
                }
            };
            document.body.addEventListener("click", el.clickOutsideEvent);
        },
        unbind(el) {
            document.body.removeEventListener("click", el.clickOutsideEvent);
        }
    });

    const app = new Vue({
        el: "#vue",
        comments: true, // needed to prevent Livewire "Multiple root elements detected" erroneous warning - https://stackoverflow.com/questions/47426675/vue-html-comment-handling
        data: {
            basket: null,
            showMiniBasket: false,
            addedProduct: null,
            alertType: null,
            alertMessage: null,
            alertShow: false
        }
    });

    // Global Vue filter to format money.
    Vue.filter("money", function(value) {
        if (!value) {
            return "0.00";
        }

        return currency(value, { symbol: "", precision: 2 }).format();
    });

    Livewire.on('basketUpdated', res => {
        app.showMiniBasket = true;
        app.basket = res.original.basket;
    })

    window.app = app;

    /**
     * Axios interceptors.
     */
    window.axios.interceptors.response.use(function(response) {
        // global messages
        if (
            response.data &&
            response.data.messages &&
            response.data.messages.length > 0
        ) {
            for (var x in response.data.messages) {
                app.alertMessage = response.data.messages[x].content;
                app.alertType = "alert-" + response.data.messages[x].type;
                app.alertShow = true;
            }
        }
        return response;
    });

    axios.get("/api/v1/basket/get").then(res => {
        if (res.data && res.data.success) {
            app.basket = res.data.basket;
        }
    });

    document.addEventListener("DOMContentLoaded", function() {
        window.livewire.on("urlReplace", url => {
            history.replaceState(null, null, url);
        });
        window.livewire.on("urlPush", url => {
            history.pushState(null, null, url);
        });

        // Accepts any class name
        var rellax = new Rellax('.rellax', {
            center: true
        });

        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('q');
        if (searchParam) {
            const searchInput = document.querySelectorAll('input[name="q"]');
            searchInput.forEach(input => {
                input.value = searchParam;
            });
        }
    });
}

function ctacardflip(){
    //cta-card
    const ctacards = document.querySelectorAll('.cta-card__footer');
    ctacards.forEach(el => {
        el.addEventListener('click',function(e){
            e.target.closest('.cta-card').classList.toggle('flipped');
        })
    });
}


function scrollControl() {
    const scrollcontrolled = document.querySelectorAll('.scroll-control');
    scrollcontrolled.forEach(el => {
        const scrollcontrol = new scrollController(el);
    });
}
window.addEventListener('load', scrollControl);
window.addEventListener('load', ctacardflip);


window.addEventListener('return-validation-success', function () {
    var returnButton = document.getElementById('return-button');

    document.getElementById('return-spinner').classList.remove('d-none');
    returnButton.classList.add('d-none');
    returnButton.classList.remove('d-inline');

    Livewire.emit('continueReturnProcess');

    setTimeout(function () {
        document.getElementById('wait-text').classList.remove('d-none');
    }, 3000);
});

// get guest_return_button and save as variable
var guestReturnButton = document.getElementById('guest_return_button');

if (guestReturnButton) {
    guestReturnButton.addEventListener('click', function() {
        document.getElementById('guest_return_spinner').classList.remove('d-none');
        guestReturnButton.classList.add('d-none');
        guestReturnButton.classList.remove('d-inline');

        setTimeout(function() {
            document.getElementById('guest_return_wait-text').classList.remove('d-none');
        }, 3000);
    });
}

var startReturnButton = document.getElementById('start-return-button');
if (startReturnButton) {
    startReturnButton.addEventListener('click', function () {
        document.getElementById('start-return-spinner').classList.remove('d-none');
        startReturnButton.classList.add('d-none');
        startReturnButton.classList.remove('d-block');

        setTimeout(function () {
            document.getElementById('start_return_wait-text').classList.remove('d-none');
        }, 3000);
    });
}

Livewire.on('initializeCollapseListeners', function() {
    Livewire.hook('message.processed', (message, component) => {
        initializeCollapseListeners();  // Reinitialize collapse listeners for all components
    });
});

function initializeCollapseListeners() {
    document.querySelectorAll('.childCollapseOpener').forEach(opener => {
        // Clean up existing listeners first by cloning the node
        const clone = opener.cloneNode(true);
        opener.parentNode.replaceChild(clone, opener);

        // Add click event listener for collapsing the child card
        clone.addEventListener('click', function(event) {
            event.preventDefault();
            const childCard = this.closest('.child');
            childCard.classList.toggle('opened');
        });
    });
}










